import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <h1>Made with ❤️ in India</h1>
      <p> By Satendra Kumar</p>
    </div>
  );
}

export default Footer;
